import React, { useEffect, useState } from 'react'
import Frame1 from '../../../../../public/assets/img/WomansCategory/s1.png'
import Frame2 from '../../../../../public/assets/img/WomansCategory/s2.png'
import Frame3 from '../../../../../public/assets/img/WomansCategory/s3.png'
import Frame4 from '../../../../../public/assets/img/WomansCategory/s4.png'
import TrendingProductBanner from '../../../../../public/assets/img/bannerBg.svg'
import MobileTrendingProductBanner from '../../../../../public/assets/img/mobileTradendingBg.png'
import TrendingProductCommon from '../TrendingProductCommon'
import { WOMEN_SECTION_TEXT } from 'src/Helpers/Json/WomanCategoryList'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useRouter } from 'next/router'
import { useAppDispatch } from 'src/store/store'
import { useSelector } from 'react-redux'
import { fetchProductByCategory } from 'src/store/slices/fetchAllProduct'

export default function TrendingProducts(props) {
  const { PageDataFun } = props
  const router = useRouter()
  const dispatch = useAppDispatch()
  const [scrollY, setScrollY] = useState(0)
  const [page, setPage] = useState(1)
  const [dataLimite, setDataLimite] = useState(30)
  const [productData, setProductData] = useState([])
  const [data, setData] = useState([])

  const productByCategory = useSelector((state: any) => state?.productByCategory)
  const newarray = []
  const newData = productByCategory?.product?.getAllProducts?.data || []
  newarray.push(newData)

  useEffect(() => {
    dispatch(
      fetchProductByCategory({
        category: 'fashion-and-accessories',
        subCategory: router?.asPath?.includes('women') ? 'women' : 'men',
        childSubCategory: router?.query?.category ? router?.query?.category : '',
        isShopifyProduct: false,
        page: page,
        limit: dataLimite,
        order: 'like_count',
      }),
    )
    if (productByCategory?.product?.getAllProducts?.data?.length > 0) {
      const products = []
      productByCategory?.product?.getAllProducts?.data.map((data, i) => {
        products.push({ index: i, ...data })
      })

      setData([...data, ...productByCategory?.product?.getAllProducts?.data])
    }
  }, [page])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (page >= 0 && page < 10) {
        setPage((prevPage) => prevPage + 1) // Increment page
      }
    }, 3000)

    return () => clearTimeout(timer) // Cleanup timeout on unmount
  }, [page])

  const Cards =
    data?.length > 0
      ? [...Array(Math.floor(Number(data?.length / 12)))]
        ?.map((prodcut, i) => {
          return [
            {
              img: null,
              type: null,
              parent_fill: true,
              child: [
                {
                  img: Frame1,
                  type: 'small',
                  product: true,
                },
                {
                  img: Frame2,
                  type: 'small',
                  product: true,
                },
              ],
            },
            {
              img: Frame4,
              type: 'large',
              parent_fill: false,
              product: true,
              child: [],
            },
            {
              img: null,
              type: null,
              parent_fill: true,
              child: [
                {
                  img: Frame2,
                  type: 'small',
                  product: true,
                },
                {
                  img: Frame1,
                  type: 'small',
                  product: true,
                },
              ],
            },
            {
              img: Frame4,
              type: 'large',
              parent_fill: false,
              product: true,
              child: [],
            },
            {
              img: Frame3,
              type: 'large',
              parent_fill: false,
              product: true,
              child: [],
            },
            {
              img: null,
              type: null,
              parent_fill: true,
              child: [
                {
                  img: Frame1,
                  type: 'small',
                  product: true,
                },
                {
                  img: Frame2,
                  type: 'small',
                  product: true,
                },
              ],
            },
            {
              img: Frame4,
              type: 'large',
              parent_fill: false,
              product: true,
              child: [],
            },
            {
              img: null,
              type: null,
              parent_fill: true,
              child: [
                {
                  img: Frame1,
                  type: 'small',
                  product: true,
                },
                {
                  img: Frame2,
                  type: 'small',
                  product: true,
                },
              ],
            },
          ]
        })
        .flat()
      : []

  useEffect(() => {
    if (Cards.length > 0) {
      let i = 0
      const result: any = Cards.map((card: any, index) => {
        // if (data[i]) {
        if (card.product && !card.parent_fill && data[i]) {
          card.product_data = data[i]
          i++
        }
        if (card.child && card.parent_fill && data[i]) {
          card.child = card.child.map((child, ind) => {
            if (child.product) {
              child.product_data = data[i]
              i++
            }
            return child
          })
        }
        return card
        // }
      })
      setProductData(result)
    }
  }, [Cards.length])

  useEffect(() => {
    const onScroll = () => {
      const scrolling = window.scrollY
      setScrollY(scrolling)
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [scrollY])

  return (
    <div className="trendingProducts-section">
      <div className="trending-back-alignment">
        <div
          className="back_details-alignment"
          onClick={() => {
            router.push('/fashion/women/', undefined, { scroll: false })
            dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
          }}
        >
          <div>
            <img src="/assets/icon/left-icon.svg" alt="back-page" />
          </div>
          <p>Woma...</p>
        </div>
        <div
          className={scrollY > 50 ? 'mobile-heading-alignment' : 'mobile-heading-alignment-none'}
          data-show={scrollY > 50 ? true : false}
        >
          <h4>Now Trending</h4>
        </div>
      </div>
      {/* <div data-show={scrollY > 50 ? false : true} className="lgviewstickyheader"> */}
      <div className="trendingProduct-banner">
        <div className="trending-banner-img-alignment">
          <img src={TrendingProductBanner.src} alt="TrendingProductBanner" />
          <div data-show={scrollY > 50 ? false : true} className="lgviewstickyheader">
            <img
              src={MobileTrendingProductBanner.src}
              alt="MobileTrendingProductBanner"
              className="mobile-view-banner"
            />
          </div>
        </div>
        <div data-show={scrollY > 50 ? false : true} className="lgviewstickyheader">
          <div className="container">
            <div className="trendingProduct-banner-section">
              <div
                className="left-arrow-alignment"
                onClick={() => {
                  router.push('/fashion/women/', undefined, { scroll: false })
                  dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
                }}
              >
                <img src="/assets/icon/leftArrow.svg" alt="left-arrow" />
              </div>

              <div className="trending-heading-alignment">
                <h4>Trending Product</h4>
                <p>{WOMEN_SECTION_TEXT.now_trending.text}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      <div className="trendingImg-gallery-section">
        <div className="container">
          <div className="trending_product_block">
            <TrendingProductCommon Cards={productData} />
          </div>
        </div>
      </div>
    </div>
  )
}
